import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type CallsComparisonTableStore } from 'pages/analytics/pages/calls/store/callsAnalyticsPageStore'
import { getColumns } from './getColumns'

interface ICallsComparisonTableProps {
  store: CallsComparisonTableStore
}

export const CallsComparisonTable = observer(({ store }: ICallsComparisonTableProps) => {
  const { tableStore, comparisonRows, breakdownFilterType } = store

  const columns = useMemo(() => getColumns(breakdownFilterType), [breakdownFilterType])

  return (
    <Table
      ariaLabel={'CallsComparisonTable'}
      store={tableStore}
      columns={columns}
      rows={comparisonRows}
      hidePagination={true}
      emptyStateProps={{
        text: 'No comparison data found',
        noIcon: true,
      }}
      scrollbarProps={{
        autoHeight: true,
        height: 'auto',
        autoHeightMax: 600,
      }}
    />
  )
})
